'use client';

import { ThemeProvider } from 'next-themes';
import type { ComponentProps } from 'react';
import { prePaintScriptProps } from './PrePaintScript';

/**
 * next-themes' ThemeProvider, with its no-flash script kept out of client
 * renders (see PrePaintScript for why). next-themes 0.4.6 is the latest
 * release and still renders a live script on every mount; this wrapper is the
 * fix until upstream ships one, after which it can go back to the plain
 * provider.
 */
export function AppThemeProvider(props: ComponentProps<typeof ThemeProvider>) {
  return <ThemeProvider {...props} scriptProps={{ ...props.scriptProps, ...prePaintScriptProps }} />;
}
